
export default class InitService{
    constructor(axios) {
        this.axios = axios;
    }

    init() {
        return this.axios
            .get("/api/constantes").then(response => response.data);
    }

}
